module.exports = __webpack_public_path__ + "static/media/thum3.ee08f43b.jpg";